import styled, { keyframes } from 'styled-components'
import { Flex, Text, Button } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'

const bunnyHeadMain = '/images/background.webp'

export const SnapSection = styled(Flex)`
  scroll-snap-type: y mandatory;
  overflow: auto;
  background-image: url(${bunnyHeadMain});
  background-size: contain;
  overflow-x: hidden;
  justify-content: center;
  padding-bottom: 3rem;
  align-items: center;
  flex-direction: column;
`
export const SnapSection2 = styled(Flex)`
  scroll-snap-type: y mandatory;
  overflow: auto;
  background-image: url(${bunnyHeadMain});
  background-size: contain;
  overflow-x: hidden;
  padding-bottom: 3rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const WelcomeText = styled(Text)`
  font-size: 1.3rem;
  letter-spacing: 1px;
  font-weight: 500;
  @media (min-width: 400px) {
    font-size: 1.7rem;
  }
  @media (min-width: 800px) {
    font-size: 1.8rem;
  }
  @media (min-width: 1000px) {
    font-size: 2.2rem;
  }
`

export const ConclusionText = styled(Text)`
  font-size: 3rem;
  font-display: swap;
  font-weight: 500;
  @media (min-width: 400px) {
    font-size: 4rem;
  }
  @media (min-width: 800px) {
    font-size: 6rem;
    margin-top: -1rem;
    font-weight: 500;
  }
  @media (min-width: 1000px) {
    font-size: 8rem;
    margin-top: -2rem;
    font-weight: 500;
  }
`
export const HeroImage = styled.div`
  position: absolute;
  top: 100px;
  bottom: 0;
  z-index: 0;
  opacity: 0.2;
  @media (min-width: 1000px) {
    display: none;
  }
`

export const HeroFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  min-height: 90vh;
  overflow: hidden;
  @media (min-width: 1000px) {
    width: 100%; 
  }
`

export const ImageWrapper = styled(Flex)`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 200px;
    box-shadow: 0 8px 7px #fff, 12px 0px 19px #0154fd, -12px 0px 24px #68b9ff;
  }
`

export const MobileWrapper = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 200px;
  box-shadow: 0 8px 7px #fff, 12px 0px 19px #0154fd, -12px 0px 24px #68b9ff;
  @media (min-width: 768px) {
    display: none;
  }
`

export const HomeConnectButton = styled(ConnectWalletButton)`
  width: 75vw;
  margin-right: 0px;
  margin-bottom: 8px;
  @media (min-width: 1000px) {
    width: 25vw;
    margin-right: 8px;
    margin-bottom: 0px;
  }
`
export const HomeSwapButton = styled(Button)`
width: 75vw; 
margin-top: 8px; 
@media (min-width: 1000px) {
  width: 25vw; 
  margin-top: 0px; 
`

// <Button
// width={['75vw', null, null, null, '25vw']}
// variant={!account ? 'secondary' : 'primary'}
// marginTop={['8px', null, null, null, '0px']}
// >
// {t('SWAP NOW')}
// </Button>
